import { el } from "./dom.js";

export const MAX_FILE_MB = 15;

// Reads a chosen .docx into { doc: { name, data } }, or { error } with a message for the user.
export async function readDocx(file) {
  if (!file.name.toLowerCase().endsWith(".docx")) return { error: "Only .docx files are supported." };
  if (file.size > MAX_FILE_MB * 1024 * 1024) return { error: `That file is over the ${MAX_FILE_MB} MB limit.` };
  try {
    return { doc: { name: file.name, data: await file.arrayBuffer() } };
  } catch {
    return { error: "Couldn't read that file." };
  }
}

// A click/keyboard/drag-and-drop target for one .docx. Append both returned nodes.
export function docxDropzone({ id, title, onFile }) {
  const hintId = `${id}-hint`;
  const input = el("input", {
    type: "file", class: "sr-only", tabindex: "-1", "aria-hidden": "true",
    accept: ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
  const dropzone = el("div", { id, class: "dropzone glass", role: "button", tabindex: "0", "aria-describedby": hintId },
    el("span", { class: "drop-title" }, title),
    el("span", { class: "drop-link" }, "or choose a file"),
    el("span", { class: "hint", id: hintId }, `.docx, up to ${MAX_FILE_MB} MB. Converted in your browser; nothing is uploaded.`));

  const take = (file) => file && onFile(file);
  dropzone.addEventListener("click", () => input.click());
  dropzone.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      input.click();
    }
  });
  dropzone.addEventListener("dragover", (event) => {
    event.preventDefault();
    dropzone.classList.add("dragover");
  });
  dropzone.addEventListener("dragleave", () => dropzone.classList.remove("dragover"));
  dropzone.addEventListener("drop", (event) => {
    event.preventDefault();
    dropzone.classList.remove("dragover");
    take(event.dataTransfer.files[0]);
  });
  input.addEventListener("change", () => {
    take(input.files[0]);
    input.value = "";
  });
  return { dropzone, input };
}
